import React from "react";

export interface HeartCxContextI {
    isHearted: (asin: string, isMetadataHearted: boolean) => boolean;
    heartAsin: (asin: string) => void;
    unheartAsin: (asin: string) => void;
    lastUpdateTimestamp: number;
}

const noOp = () => { /* NoOp */ };
const noOpBool = () => false;
const HeartCxContext = React.createContext<HeartCxContextI>({
    isHearted: noOpBool,
    heartAsin: noOp,
    unheartAsin: noOp,
    lastUpdateTimestamp: 0,
});

export default HeartCxContext;
